import axios from "axios";
import { baseUrl } from "../config/url";

export interface IParams {
  address: string;
  network: string | undefined;
}

export const validateAddressService = (param: IParams) =>
  axios.post(`${baseUrl}validateAddress`, param, { withCredentials: true });
